import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TerceroUpPasarelaTarifaService } from '../../../_services/tercero-up-pasarela-tarifa.service';
import { TerceroUPPasarelaTarifa } from '../../../_models/tercero-up-pasarela-tarifa';
import { NavService } from '../../../_services/_nav.service';
import { AppSettingService } from '../../../_services/app-setting.service';
import { AdjuntoService } from '../../../_services/adjunto.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { AdmsbMedioFila, AdmsbMetodoNodo } from '../../../_models/admsb-arbol';
import { AdmsbConceptoTarifaItem } from '../../../_models/admsb-tarifa';
import { LoadingModule } from '../../../shared/loading/loading.module';

@Component({
  selector: 'app-admsb-tarifas',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SidebarModule,
    ButtonModule,
    InputTextModule,
    LoadingModule,
  ],
  schemas: [NO_ERRORS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './admsb-tarifas.component.html',
  styleUrls: ['./admsb-tarifas.component.scss'],
})
export class AdmsbTarifasComponent implements OnInit, OnChanges {

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() medio: AdmsbMedioFila | null = null;
  @Input() metodo: AdmsbMetodoNodo | null = null;
  @Input() idTitular: string;
  @Input() baseZIndex = 20000;
  @Input() appendTo: any = 'body';
  @Output() guardado = new EventEmitter<{ respuesta: TerceroUPPasarelaTarifa; medio: AdmsbMedioFila }>();
  @Output() cerrado = new EventEmitter<void>();

  cargando = false;
  guardando = false;
  esModoRuta = false;
  idTerceroUPPasarelaProducto: string | null = null;

  readonly ICONO_POR_DEFECTO = 'assets/icons/perfil-crezcamos/icon-crezcamos.svg';
  iconoUrl: SafeUrl | string = this.ICONO_POR_DEFECTO;
  cargandoIcono = false;
  private idAdjuntoCargado: string | null = null;

  conceptosTarifas: AdmsbConceptoTarifaItem[] = [];
  private snapshotTarifas: { [campo: string]: number | string | null | undefined } = {};

  readonly DEFINICIONES_CONCEPTOS_TARIFA: Array<{
    campo: string;
    campoBase: string;
    labelClave: string;
    tipo: 'porcentaje' | 'moneda' | 'numero';
  }> = [
    {
      campo: 'tarifaTrxVentaPorcentaje',
      campoBase: 'configTarifaTrxVentaPorcentaje',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_COMISIONPORVENTA',
      tipo: 'porcentaje'
    },
    {
      campo: 'tarifaTrxIndividual',
      campoBase: 'configTarifaTrxIndividual',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFA_TRANSACCION_INDIVIDUAL',
      tipo: 'moneda'
    },
    {
      campo: 'montoMinimoTrx',
      campoBase: 'configMontoMinimoTrx',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VENTAMINIMA',
      tipo: 'moneda'
    },
    {
      campo: 'montoMaximoTrx',
      campoBase: 'configMontoMaximoTrx',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VENTA_MAXIMA_COLON',
      tipo: 'moneda'
    },
    {
      campo: 'limiteTrxDiario',
      campoBase: 'configLimiteTrxDiario',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_LIMITE_RECAUDOS_AL_DIA',
      tipo: 'numero'
    },
    {
      campo: 'limiteTrxMes',
      campoBase: 'configLimiteTrxMes',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_LIMITE_RECAUDOS_AL_MES',
      tipo: 'numero'
    },
    {
      campo: 'montoMaximoMes',
      campoBase: 'configMontoMaximoMes',
      labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MONTO_MAXIMO_POR_MES',
      tipo: 'moneda'
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private terceroUpPasarelaTarifaServicio: TerceroUpPasarelaTarifaService,
    private navService: NavService,
    private appSettingService: AppSettingService,
    private adjuntoService: AdjuntoService,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const idRuta = this.route?.snapshot?.paramMap?.get('id');
    const idProductoRuta = this.route?.snapshot?.paramMap?.get('idTerceroUPPasarelaProducto');

    if (idProductoRuta && !this.medio) {
      this.esModoRuta = true;
      this.idTitular = this.idTitular || idRuta;
      this.idTerceroUPPasarelaProducto = idProductoRuta;
      this.cargando = true;

      this.terceroUpPasarelaTarifaServicio.listMetodosPasarelaTarifas(idProductoRuta).subscribe({
        next: filas => {
          this.cargando = false;
          if (filas && filas.length) {
            const fila = filas[0];
            const esActivo = !!fila.indicadorHabilitado;
            this.medio = {
              idMedio: fila.idMedioPago,
              nombreMedio: fila.nombreMedioPago || fila.codigoMedioPago,
              idProductoPasarelaTarifa: fila.idProductoPasarelaTarifa,
              idMedioPago: fila.idMedioPago,
              codigoMedioPago: fila.codigoMedioPago,
              nombreMedioPago: fila.nombreMedioPago || fila.codigoMedioPago,
              idAdjuntoIcono: fila.idAdjuntoIcono || (fila as any).idAdjuntoIcono || null,
              nombreAdjuntoIcono: fila.nombreAdjuntoIcono || (fila as any).nombreAdjuntoIcono || null,
              estado: esActivo ? 'ACTIVO' : 'INACTIVO',
              codigoEstado: esActivo ? 'MEDACT' : 'MEDINA',
              comisionVentaPorcentaje: fila.tarifaTrxVentaPorcentaje ?? fila.configTarifaTrxVentaPorcentaje ?? 0,
              tarifaTrxIndividual: fila.tarifaTrxIndividual ?? fila.configTarifaTrxIndividual ?? 0,
              ventaMinima: fila.montoMinimoTrx ?? fila.configMontoMinimoTrx ?? 0,
              ventaMaxima: fila.montoMaximoTrx ?? fila.configMontoMaximoTrx ?? 0,
              limiteDiaRecaudos: fila.limiteTrxDiario ?? fila.configLimiteTrxDiario ?? 0,
              limiteMesRecaudos: fila.limiteTrxMes ?? fila.configLimiteTrxMes ?? 0,
              limiteMesMonto: fila.montoMaximoMes ?? fila.configMontoMaximoMes ?? 0,
              indicadorAplicaTarifaEspecial: !!fila.indicadorAplicaTarifaEspecial,
              indicadorHabilitado: esActivo,
              raw: fila
            };
            this.inicializarConceptos();
            this.cargarIconoMedio();
            this.visible = true;
            this.cd.markForCheck();
          }
        },
        error: () => {
          this.cargando = false;
          this.cd.markForCheck();
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const cambioMedio = !!(changes['medio'] && this.medio);
    const abriendoSidebar = !!(changes['visible'] && changes['visible'].currentValue && this.medio);

    if (cambioMedio || abriendoSidebar) {
      this.inicializarConceptos();
      this.cargarIconoMedio();

      if (this.medio) {
        this.cargando = true;
        this.obtenerTarifaBaseParaActualizacion$(this.medio).subscribe({
          next: tarifaCompleta => {
            this.cargando = false;
            if (tarifaCompleta && this.medio) {
              this.medio.raw = {
                ...tarifaCompleta,
                ...this.medio.raw,
                configTarifaTrxVentaPorcentaje: tarifaCompleta.configTarifaTrxVentaPorcentaje,
                configTarifaTrxIndividual: tarifaCompleta.configTarifaTrxIndividual,
                configMontoMinimoTrx: tarifaCompleta.configMontoMinimoTrx,
                configMontoMaximoTrx: tarifaCompleta.configMontoMaximoTrx,
                configLimiteTrxDiario: tarifaCompleta.configLimiteTrxDiario,
                configLimiteTrxMes: tarifaCompleta.configLimiteTrxMes,
                configMontoMaximoMes: tarifaCompleta.configMontoMaximoMes
              };
              this.inicializarConceptos();
              this.cd.markForCheck();
            }
          },
          error: () => {
            this.cargando = false;
            this.cd.markForCheck();
          }
        });
      }
    }
  }

  inicializarConceptos(): void {
    if (!this.medio) {
      return;
    }
    const raw = this.medio.raw || ({} as TerceroUPPasarelaTarifa);
    const rawAny = raw as any;
    this.snapshotTarifas = {};

    this.conceptosTarifas = this.DEFINICIONES_CONCEPTOS_TARIFA.map(def => {
      const tarifaBase = (rawAny[def.campoBase] !== undefined && rawAny[def.campoBase] !== null)
        ? rawAny[def.campoBase]
        : 0;
      const tienePreferencial = rawAny[def.campo] !== undefined && rawAny[def.campo] !== null;
      const tarifaAsignada = tienePreferencial ? rawAny[def.campo] : tarifaBase;
      const esIgualABase = tienePreferencial && Number(rawAny[def.campo]) === Number(tarifaBase);
      const tarifaPreferencial = (tienePreferencial && !esIgualABase && Number(rawAny[def.campo]) !== 0)
        ? rawAny[def.campo]
        : null;

      this.snapshotTarifas[def.campo] = tarifaPreferencial;

      return {
        campo: def.campo,
        campoBase: def.campoBase,
        labelClave: def.labelClave,
        tipo: def.tipo,
        tarifaBase,
        tarifaAsignada,
        tarifaPreferencial
      };
    });
  }

  validarRangosTarifas(): boolean {
    // 1. Validar que límites y montos no admitan valores negativos
    for (const c of this.conceptosTarifas) {
      const v = c.tarifaPreferencial;
      if (v !== null && v !== undefined && v !== '' && !isNaN(Number(v))) {
        if (Number(v) < 0) {
          this.navService.setMesageToast({
            severity: 'warn',
            summary: this.navService.buscarMensaje('LBL_ADVERTENCIA'),
            detail: this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_ERROR_VALORES_NEGATIVOS')
          });
          return false;
        }
      }
    }

    // 2. Validar que la comisión por venta oscile en el rango [0% - 100%]
    const cComision = this.conceptosTarifas.find(c => c.campo === 'tarifaTrxVentaPorcentaje');
    if (cComision && cComision.tarifaPreferencial !== null && cComision.tarifaPreferencial !== undefined && cComision.tarifaPreferencial !== '' && !isNaN(Number(cComision.tarifaPreferencial))) {
      const comision = Number(cComision.tarifaPreferencial);
      if (comision < 0 || comision > 100) {
        this.navService.setMesageToast({
          severity: 'warn',
          summary: this.navService.buscarMensaje('LBL_ADVERTENCIA'),
          detail: this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_ERROR_COMISION_RANGO')
        });
        return false;
      }
    }

    // 3. Validar consistencia: venta mínima no puede ser estrictamente mayor a venta máxima
    const cMin = this.conceptosTarifas.find(c => c.campo === 'montoMinimoTrx');
    const cMax = this.conceptosTarifas.find(c => c.campo === 'montoMaximoTrx');
    const tieneMin = cMin && cMin.tarifaPreferencial !== null && cMin.tarifaPreferencial !== undefined && cMin.tarifaPreferencial !== '' && !isNaN(Number(cMin.tarifaPreferencial));
    const tieneMax = cMax && cMax.tarifaPreferencial !== null && cMax.tarifaPreferencial !== undefined && cMax.tarifaPreferencial !== '' && !isNaN(Number(cMax.tarifaPreferencial));

    if (tieneMin && tieneMax) {
      const min = Number(cMin?.tarifaPreferencial);
      const max = Number(cMax?.tarifaPreferencial);
      if (min > max) {
        this.navService.setMesageToast({
          severity: 'warn',
          summary: this.navService.buscarMensaje('LBL_ADVERTENCIA'),
          detail: this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_ERROR_VENTA_MIN_MAYOR_MAX')
        });
        return false;
      }
    }

    return true;
  }

  cerrar(): void {
    if (this.conceptosTarifas && this.conceptosTarifas.length) {
      this.conceptosTarifas.forEach(c => {
        c.tarifaPreferencial = this.snapshotTarifas[c.campo];
      });
    }
    this.visible = false;
    this.visibleChange.emit(false);
    this.cerrado.emit();

    if (this.esModoRuta) {
      this.location.back();
    }
  }

  private obtenerTarifaBaseParaActualizacion$(medio: AdmsbMedioFila): Observable<TerceroUPPasarelaTarifa> {
    const raw = medio?.raw || ({} as TerceroUPPasarelaTarifa);
    const idProductoPasarelaTarifa = raw?.idProductoPasarelaTarifa || medio?.idProductoPasarelaTarifa;
    const idTitular = this.idTitular || raw?.idTerceroUPPasarela;
    if (!idTitular || !idProductoPasarelaTarifa) {
      return of(raw);
    }
    return this.terceroUpPasarelaTarifaServicio.obtenerTercerosUPPasarelasTarifas(idTitular, idProductoPasarelaTarifa).pipe(
      map(res => res || raw),
      catchError(() => of(raw))
    );
  }

  verificarTarifaIgualABase(c: AdmsbConceptoTarifaItem): void {
    if (c.tarifaPreferencial !== null && c.tarifaPreferencial !== undefined && c.tarifaPreferencial !== '' && !isNaN(Number(c.tarifaPreferencial))) {
      const num = Number(c.tarifaPreferencial);
      if (num === Number(c.tarifaBase) || num === 0) {
        c.tarifaPreferencial = null;
        this.cd.markForCheck();
      }
    }
  }

  private resolverValorAGuardar(c: AdmsbConceptoTarifaItem, tarifaActual?: TerceroUPPasarelaTarifa): number {
    const valor = c.tarifaPreferencial;
    const esNullOVacio = valor === null || valor === undefined || valor === '' || isNaN(Number(valor));
    const numValor = !esNullOVacio ? Number(valor) : null;
    const numBase = c.tarifaBase !== null && c.tarifaBase !== undefined && !isNaN(Number(c.tarifaBase)) ? Number(c.tarifaBase) : null;

    // Si la tarifa preferencial es 0, null/vacío o igual a la base -> se envía a guardar el valor de la tarifa base
    if (esNullOVacio || numValor === 0 || (numBase !== null && numValor === numBase)) {
      const baseDesdeRegistro = tarifaActual ? (tarifaActual as any)[c.campoBase] : null;
      const baseFinal = numBase !== null
        ? numBase
        : (baseDesdeRegistro !== null && baseDesdeRegistro !== undefined ? Number(baseDesdeRegistro) : 0);
      return baseFinal;
    }

    return numValor!;
  }

  guardar(): void {
    if (!this.medio || this.guardando) {
      return;
    }

    if (!this.validarRangosTarifas()) {
      return;
    }

    const medio = this.medio;
    const raw = medio.raw || ({} as TerceroUPPasarelaTarifa);

    this.guardando = true;

    const tieneTarifaPreferencialActiva = this.conceptosTarifas.some(c => {
      const v = c.tarifaPreferencial;
      if (v === null || v === undefined || v === '' || isNaN(Number(v))) {
        return false;
      }
      const num = Number(v);
      const numBase = c.tarifaBase !== null && c.tarifaBase !== undefined && !isNaN(Number(c.tarifaBase)) ? Number(c.tarifaBase) : null;
      return num !== 0 && (numBase === null || num !== numBase);
    });

    this.obtenerTarifaBaseParaActualizacion$(medio).pipe(
      switchMap((tarifaActual) => {
        const registro: TerceroUPPasarelaTarifa = {
          ...tarifaActual,
          idTerceroUPPasarelaProducto: this.metodo?.idTerceroUPPasarelaProducto || this.idTerceroUPPasarelaProducto || tarifaActual?.idTerceroUPPasarelaProducto || raw?.idTerceroUPPasarelaProducto,
          indicadorHabilitado: true,
          indicadorAplicaTarifaEspecial: tieneTarifaPreferencialActiva,
          codigoEstadoMedio: tarifaActual?.codigoEstadoMedio || raw?.codigoEstadoMedio || medio.codigoEstado || 'MEDACT',
          estadoMedio: tarifaActual?.estadoMedio || raw?.estadoMedio || medio.estado || 'ACTIVO',
          idEstadoMedioPago: tarifaActual?.idEstadoMedioPago || (tarifaActual as any)?.IdEstadoMedioPago || raw?.idEstadoMedioPago || (medio as any)?.idEstadoMedioPago || null,
          IdEstadoMedioPago: (tarifaActual as any)?.IdEstadoMedioPago || tarifaActual?.idEstadoMedioPago || raw?.IdEstadoMedioPago || (medio as any)?.IdEstadoMedioPago || null
        };

        this.conceptosTarifas.forEach(c => {
          (registro as any)[c.campo] = this.resolverValorAGuardar(c, tarifaActual);
        });

        return this.terceroUpPasarelaTarifaServicio.guardarPasarelaVersion(registro);
      })
    ).subscribe({
      next: (respuesta) => {
        this.guardando = false;
        medio.raw = {
          ...medio.raw,
          ...respuesta
        };
        medio.comisionVentaPorcentaje = medio.raw.tarifaTrxVentaPorcentaje ?? medio.raw.configTarifaTrxVentaPorcentaje ?? 0;
        medio.tarifaTrxIndividual = medio.raw.tarifaTrxIndividual ?? medio.raw.configTarifaTrxIndividual ?? 0;
        medio.ventaMinima = medio.raw.montoMinimoTrx ?? medio.raw.configMontoMinimoTrx ?? 0;
        medio.ventaMaxima = medio.raw.montoMaximoTrx ?? medio.raw.configMontoMaximoTrx ?? 0;
        medio.limiteDiaRecaudos = medio.raw.limiteTrxDiario ?? medio.raw.configLimiteTrxDiario ?? 0;
        medio.limiteMesRecaudos = medio.raw.limiteTrxMes ?? medio.raw.configLimiteTrxMes ?? 0;
        medio.limiteMesMonto = medio.raw.montoMaximoMes ?? medio.raw.configMontoMaximoMes ?? 0;
        medio.indicadorAplicaTarifaEspecial = tieneTarifaPreferencialActiva;

        this.navService.setMesageToast({
          severity: 'success',
          summary: this.navService.buscarMensaje('LBL_CONFIRMACION'),
          detail: this.navService.buscarMensaje('ADMINISTRADORSERVICIOSBANCARIOS.MSG_TARIFAS_ACTUALIZADAS_EXITO')
        });

        this.visible = false;
        this.visibleChange.emit(false);
        this.guardado.emit({ respuesta, medio });

        if (this.esModoRuta) {
          this.location.back();
        }
      },
      error: () => {
        this.guardando = false;
        this.navService.setMesage(3);
      }
    });
  }

  prefijoTarifa(tipo: string): string {
    return tipo === 'moneda' ? '$ ' : '';
  }

  sufijoTarifa(tipo: string): string {
    return tipo === 'porcentaje' ? ' %' : '';
  }

  maxEnterosTarifa(tipo: string): number {
    return tipo === 'porcentaje' ? 3 : 12;
  }

  maxDecimalesTarifa(tipo: string): number {
    return tipo === 'numero' ? 0 : 2;
  }

  formatearValorTarifa(valor: number | null | undefined, tipo: string): string {
    if (valor === null || valor === undefined) {
      return '-';
    }
    const num = Number(valor);
    if (isNaN(num)) {
      return '-';
    }
    if (tipo === 'porcentaje') {
      return `${num}%`;
    }
    const parteEntera = Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (tipo === 'moneda') {
      return `$${parteEntera}`;
    }
    return parteEntera;
  }

  /**
   * Carga el ícono del medio de pago en binario a través de adjuntoService.descargarArchivo.
   * Evita llamados duplicados al verificar si la consulta ya está en curso o ya fue resuelta para el mismo id.
   * Convierte el archivo binario (Blob) a Data URL seguro y aplica fallback al ícono institucional si no tiene id o ante error.
   */
  cargarIconoMedio(): void {
    const idAdjunto = this.medio?.idAdjuntoIcono ||
                      this.medio?.raw?.idAdjuntoIcono ||
                      (this.medio as any)?.idAdjuntoIcono ||
                      (this.medio?.raw as any)?.idAdjuntoIcono;

    if (!idAdjunto) {
      this.idAdjuntoCargado = null;
      this.iconoUrl = this.ICONO_POR_DEFECTO;
      return;
    }

    // Evitar llamados duplicados si ya se está cargando o ya se procesó este id
    if (this.cargandoIcono || this.idAdjuntoCargado === idAdjunto) {
      return;
    }

    this.cargandoIcono = true;
    this.idAdjuntoCargado = idAdjunto;

    this.adjuntoService.descargarArchivo(idAdjunto).subscribe({
      next: (blob: any) => {
        this.cargandoIcono = false;
        if (!blob) {
          this.iconoUrl = this.ICONO_POR_DEFECTO;
          this.cd.markForCheck();
          return;
        }

        // Si la respuesta es un Blob binario
        if (blob instanceof Blob) {
          if (blob.size === 0) {
            this.iconoUrl = this.ICONO_POR_DEFECTO;
            this.cd.markForCheck();
            return;
          }
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            const dataUrl = reader.result ? reader.result.toString() : '';
            this.iconoUrl = dataUrl
              ? this.sanitizer.bypassSecurityTrustUrl(dataUrl)
              : this.ICONO_POR_DEFECTO;
            this.cd.markForCheck();
          }, false);
          reader.addEventListener('error', () => {
            this.iconoUrl = this.ICONO_POR_DEFECTO;
            this.cd.markForCheck();
          }, false);
          reader.readAsDataURL(blob);
        } else if (typeof blob === 'string') {
          // Si vino codificado en base64/dataUrl como string
          this.iconoUrl = this.formatearIconoBase64(blob, this.medio?.nombreAdjuntoIcono);
          this.cd.markForCheck();
        } else if (blob.adjuntoBase64 || blob.base64 || blob.adjunto) {
          const rawBase64 = blob.adjuntoBase64 || blob.base64 || blob.adjunto;
          this.iconoUrl = this.formatearIconoBase64(rawBase64, blob.nombreArchivo || this.medio?.nombreAdjuntoIcono);
          this.cd.markForCheck();
        } else {
          this.iconoUrl = this.ICONO_POR_DEFECTO;
          this.cd.markForCheck();
        }
      },
      error: () => {
        this.cargandoIcono = false;
        this.iconoUrl = this.ICONO_POR_DEFECTO;
        this.cd.markForCheck();
      }
    });
  }

  private formatearIconoBase64(base64: string, nombreArchivo?: string): SafeUrl | string {
    if (!base64) {
      return this.ICONO_POR_DEFECTO;
    }
    if (base64.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustUrl(base64);
    }
    let mimeType = 'image/png';
    const ext = nombreArchivo ? nombreArchivo.split('.').pop()?.toLowerCase() : '';
    if (ext === 'svg' || base64.trim().startsWith('<svg') || base64.startsWith('PHN2')) {
      mimeType = 'image/svg+xml';
    } else if (ext === 'jpg' || ext === 'jpeg' || base64.startsWith('/9j/')) {
      mimeType = 'image/jpeg';
    } else if (ext === 'gif' || base64.startsWith('R0lG')) {
      mimeType = 'image/gif';
    } else if (ext === 'png' || base64.startsWith('iVBO')) {
      mimeType = 'image/png';
    }

    if (base64.trim().startsWith('<svg')) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:image/svg+xml;utf8,${encodeURIComponent(base64)}`);
    }

    return this.sanitizer.bypassSecurityTrustUrl(`data:${mimeType};base64,${base64}`);
  }

  onIconoError(event?: Event): void {
    if (this.iconoUrl !== this.ICONO_POR_DEFECTO) {
      this.iconoUrl = this.ICONO_POR_DEFECTO;
      this.cd.markForCheck();
    } else if (event && event.target) {
      (event.target as HTMLElement).style.display = 'none';
    }
  }
}
